import {
  type FinancialAccountTypeEnum,
  FinancialAccountTypes,
} from '../enums/FinancialAccountTypeEnum'

export interface FinancialAccountBankingDetailsConstructor {
  name: string
  accountNumber: string
  routingNumber: string | undefined
  institutionNumber: string | undefined
  transitNumber: string | undefined
  sortCode: string | undefined
}

export class FinancialAccountBankingDetails {
  name: string
  accountNumber: string
  routingNumber: string | undefined
  institutionNumber: string | undefined
  transitNumber: string | undefined
  sortCode: string | undefined

  constructor(data: FinancialAccountBankingDetailsConstructor) {
    this.name = data.name
    this.accountNumber = data.accountNumber
    this.routingNumber = data.routingNumber
    this.institutionNumber = data.institutionNumber
    this.transitNumber = data.transitNumber
    this.sortCode = data.sortCode
  }

  get type(): FinancialAccountTypeEnum {
    if (this.routingNumber) {
      return FinancialAccountTypes.AIRWALLEX_USD
    } else if (this.institutionNumber && this.transitNumber) {
      return FinancialAccountTypes.AIRWALLEX_CAD
    } else if (this.sortCode) {
      return FinancialAccountTypes.AIRWALLEX_GBP
    } else {
      throw new Error('Invalid account type')
    }
  }

  get fields() {
    switch (this.type) {
      case FinancialAccountTypes.AIRWALLEX_USD:
        return {
          name: this.name,
          accountNumber: this.accountNumber,
          routingNumber: this.routingNumber,
        }
      case FinancialAccountTypes.AIRWALLEX_CAD:
        return {
          name: this.name,
          accountNumber: this.accountNumber,
          institutionNumber: this.institutionNumber,
          transitNumber: this.transitNumber,
        }
      case FinancialAccountTypes.AIRWALLEX_GBP:
        return {
          name: this.name,
          sortCode: this.sortCode?.match(/\d{2}/g)?.join('-'),
          accountNumber: this.accountNumber?.match(/\d{4}/g)?.join('-'),
        }
      default:
        return {}
    }
  }
}
